import React from "react";
import { Accordion } from "react-bootstrap";
import { Answer } from ".";
import { QuestionInterface, AnswerInterface, ArrayHelper, PendingCommand } from "../../helpers";

interface Props {
  subscriptionData?: any,
  questions: QuestionInterface[],
  answers: AnswerInterface[],
  updateValue?: (questionId: number, newValue: string) => void,
  sendCommand: (cmd: PendingCommand) => void
}

export const Answers: React.FC<Props> = props => {

  const getQuestions = (currentQuestions: QuestionInterface[]) => {
    const result: React.ReactElement[] = [];
    currentQuestions.forEach(q => {
      const a = ArrayHelper.getOne(props.answers, "questionId", q.id);
      result.push(<Answer key={"q" + q.id + "a" + a?.id} subscriptionData={props.subscriptionData} question={q} answer={a} updateValue={props.updateValue} allQuestions={props.questions} allAnswers={props.answers} sendCommand={props.sendCommand} />);
    });
    return result;
  }

  const getContent = () => {
    const defaultKey = (props.questions && props.questions.length > 0) ? props.questions[0].title : "";
    return <Accordion defaultActiveKey={defaultKey} >{getQuestions(props.questions)}</Accordion>
  }

  return (
    <>
      {getContent()}
    </>
  );
}